import { conditionalString } from '@strata/helper-functions';
import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Items = {
    TASK: 'task',
    SUBTASK: 'subtask',
    CONDITION: 'condition',
    VALUE_CASE: 'value case',
};

const itemToDeletePhraseMap = {
    [Items.TASK]: 'Task, its Subtask(s), and its Condition(s)',
    [Items.SUBTASK]: 'Subtask and its Condition(s)',
    [Items.CONDITION]: 'Condition',
    [Items.VALUE_CASE]: 'Value Case',
};

export const DeleteItemDialog = ({
    itemToDelete = undefined,
    isOpen = undefined,
    onCancel,
    onDelete = () => {},
    itemPreview = undefined,
}) => {
    const itemToDeleteStr = conditionalString(!!itemToDelete, ` ${itemToDelete}`);
    return (
        <WarningDialog
            dialogTitle={`Delete${itemToDeleteStr}`}
            isOpen={isOpen}
            primaryButtonLabel={`Yes, delete${itemToDeleteStr}`}
            primaryButtonIntent={Button.Intent.DANGER}
            secondaryButtonLabel="Cancel"
            onSecondaryButtonClick={onCancel}
            onPrimaryButtonClick={onDelete}
            width={600}
            dialogContent={
                <div className="sds_performance__dialog-content">
                    <div className="padding__bottom--medium">
                        Are you sure you want to delete this
                        {conditionalString(
                            !!itemToDelete,
                            ` ${itemToDeletePhraseMap[itemToDelete]}`,
                        )}
                        ?
                    </div>
                    <div
                        className={classNames({
                            'sds_performance__delete-item-preview': typeof itemPreview !== 'string',
                            'font-semi-bold': typeof itemPreview === 'string',
                            'padding__bottom--small': typeof itemPreview === 'string',
                        })}
                    >
                        {itemPreview}
                    </div>
                </div>
            }
        />
    );
};

DeleteItemDialog.propTypes = {
    itemToDelete: PropTypes.oneOf(Object.values(Items)),
    isOpen: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    itemPreview: PropTypes.node,
};

DeleteItemDialog.Items = Items;
